import { combineReducers } from "redux";
import commonReducer from "./common-reducer";
import adminReducer from "./admin-reducer";
import projectManagementReducer from "./project-management-reducer";
import resourceManagementReducer from "./resource-management-reducer";
import financialManagementReducer from "./financial-management-reducer";
import forgotPasswordReducer from "./forgot-password-reducer";
import chatReducer from "./chat-reducer";

export default combineReducers({
  commonReducer,
  adminReducer,
  projectManagementReducer,
  resourceManagementReducer,
  financialManagementReducer,
  forgotPasswordReducer,
  chatReducer,
});
